document.addEventListener("DOMContentLoaded", function () {
  initLineCharts();
});

/**
 * Main initialization function for line charts
 * Creates various line charts for workforce and scam data
 */
function initLineCharts() {
  google.charts.load("current", { packages: ["corechart"] });
  google.charts.setOnLoadCallback(() => {
    drawIndividualWorkforceCharts();
    drawScamChartGroup(
      apiData.flourishScamSection.byMethod.data.data,
      "Method",
      ["Wireless/Mobile", "Wired", "VOIP"],
      ["#2e3192", "#dc3912", "#ff9900"]
    );
    drawScamChartGroup(
      apiData.flourishScamSection.byType.data.data,
      "Type",
      ["Pre-recorded Voice", "Live Voice", "Abandoned Calls", "Text Message"],
      ["#2e3192", "#dc3912", "#ff9900", "#109618"]
    );
  });

  /**
   * Helper function to get line chart options
   */
  function getChartOptions(title, color) {
    const isMobile = window.innerWidth < 768;
    const titleFontSize = isMobile ? 12 : 14;
    
    return {
      title: title,
      titleTextStyle: {
        fontSize: titleFontSize,
        bold: true
      },
      legend: { position: "bottom" },
      curveType: "function",
      lineWidth: 4,
      pointSize: 6,
      animation: {
        duration: 1000,
        easing: "out",
        startup: true,
      },
      chartArea: {
        left: 40,
        width: "80%",
        height: "70%",
      },
      hAxis: {
        title: "Year",
        slantedText: true,
        showTextEvery: 1,
        format: '####'
      },
      vAxis: {
        title: "%",
        gridlines: {
          count: 6,
        },
        slantedText: true,
      },
      colors: [color],
    };
  }

  /**
   * Creates workforce line charts
   * HTML Element IDs used:
   * - laborForceChart: Labor Force Participation Rate
   * - employmentRatioChart: Employment to Population Ratio
   * - unemploymentRateChart: Unemployment Rate
   */
  function drawIndividualWorkforceCharts() {
    const participationElement = document.getElementById("laborForceChart");
    const employmentElement = document.getElementById("employmentRatioChart");
    const unemploymentElement = document.getElementById("unemploymentRateChart");
    
    if (!participationElement && !employmentElement && !unemploymentElement) {
      return;
    }

    const rawData = apiData.flourishDemographic.byWorkForce.data.data;
    const years = rawData.slice(1).map((row) => row[0]);

    const participationData = new google.visualization.DataTable();
    participationData.addColumn("string", "Year");
    participationData.addColumn("number", "Participation Rate");
    years.forEach((year, i) => {
      participationData.addRow([year, parseFloat(rawData[i + 1][1])]);
    });

    const employmentData = new google.visualization.DataTable();
    employmentData.addColumn("string", "Year");
    employmentData.addColumn("number", "Employment Ratio");
    years.forEach((year, i) => {
      employmentData.addRow([year, parseFloat(rawData[i + 1][2])]);
    });

    const unemploymentData = new google.visualization.DataTable();
    unemploymentData.addColumn("string", "Year");
    unemploymentData.addColumn("number", "Unemployment Rate");
    years.forEach((year, i) => {
      unemploymentData.addRow([year, parseFloat(rawData[i + 1][3])]);
    });

    if (participationElement) {
      new google.visualization.LineChart(participationElement).draw(
      participationData,
        getChartOptions("Labor Force Participation Rate", "#2e3192"),
    );
    }

    if (employmentElement) {
      new google.visualization.LineChart(employmentElement).draw(
      employmentData,
      getChartOptions("Employment to Population Ratio", "#dc3912"),
    );
    }

    if (unemploymentElement) {
      new google.visualization.LineChart(unemploymentElement).draw(
        unemploymentData, 
        getChartOptions("Unemployment Rate", "#ff9900")
      );
    }
  }

  /**
   * Creates scam method/type line charts
   * HTML Element IDs dynamically created:
   * - For Method group: googleChartMethodWirelessMobile, googleChartMethodWired, googleChartMethodVOIP
   * - For Type group: googleChartTypePrerecordedVoice, googleChartTypeLiveVoice,
   *                  googleChartTypeAbandonedCalls, googleChartTypeTextMessage
   * 
   * @param {Array} rawData - Data for chart
   * @param {string} groupLabel - Group label (Method/Type)
   * @param {Array} metricLabels - Labels for each metric
   * @param {Array} colors - Colors for each chart
   */
  function drawScamChartGroup(rawData, groupLabel, metricLabels, colors) {
    const years = rawData.slice(1).map((row) => row[0]);

    metricLabels.forEach((label, index) => {
      const dataTable = new google.visualization.DataTable();
      dataTable.addColumn("string", "Year");
      dataTable.addColumn("number", label);

      years.forEach((year, i) => {
        dataTable.addRow([year, parseInt(rawData[i + 1][index + 1])]);
      });

      const chartOptions = {
        title: `${label} Complaints by ${groupLabel}`,
        legend: { position: "none" },
        colors: [colors[index]],
        chartArea: {
          left: 60,
          right: 20,
          top: 40,
          bottom: 60,
          width: "80%",
          height: "70%",
        },
        hAxis: {
          title: "Year",
          slantedText: true,
          textStyle: { fontSize: 10 },
        },
        vAxis: {
          title: "# of Complaints",
          textStyle: { fontSize: 10 },
          gridlines: { count: 6 },
        },
      };

      // Creates element ID like: googleChartMethodWirelessMobile or googleChartTypeLiveVoice
      const chartId = `googleChart${groupLabel}${label.replace(/[^a-zA-Z]/g, "")}`;
      const chartContainer = document.getElementById(chartId);
      if (chartContainer) {
        new google.visualization.LineChart(chartContainer).draw(
          dataTable,
          chartOptions,
        );
      }
    });
  }
}

export default initLineCharts; 